import { useForm } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  teachingPractices: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const WellRun: React.FC<AnswersProps> = ({ answersData, onAnswerChange }) => {
  const defaultValues = {
    teachingPractices: answersData.find((answer) => answer.systemCodeId === 250)
      ?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  return (
    <Grid container p={2} spacing={2}>
      <Grid item xs={12}>
        <Typography fontSize={18} fontWeight={700} mb={2}>
          A Well-Run, Purposeful Program
        </Typography>
        <Typography mb={2}>
          How do your teaching practices help you ensure your program is
          well-run, purposeful, and responsive to participants’ needs?
        </Typography>
        <ReadMoreReadLess>
          <ul>
            <li>
              What activities did you create to support individual children to
              promote inclusive, welcoming environments for all children?
            </li>
            <li>
              What opportunities have been made to initiate and maintain
              connections with community resources to meet the needs of
              individual children and families?
            </li>
            <li>How do you monitor the health and safety for each child?</li>
            <li>
              How do you ensure materials and equipment are appropriate to the
              developmental needs of children?
            </li>
          </ul>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12}>
        <TextField
          {...register("teachingPractices")}
          name="teachingPractices"
          label="I work to ensure that my program helps by "
          fullWidth
          multiline
          rows={2}
          value={
            answersData.find((answer) => answer.systemCodeId === 250)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 250;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.teachingPractices?.message}
          helperText={errors.teachingPractices?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.teachingPractices?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default WellRun;
